import React, { PureComponent } from 'react';

export default class ProgressBar extends PureComponent  {
    static defaultProps = {
        showProgress: true
    }

    render() {
        return (
            <div className={'progress-bar' + (this.props.progress === 100 ? ' completed' : '')}>
                {
                    this.props.showProgress ? (
                        <span className="progress-bar-value">
                            {this.props.progress}%
                        </span>
                    ) : null
                }

                <div className="progress-bar-main">
                    <div className="progress-bar-progress" style={{width: `${this.props.progress}%`}} />
                </div>
            </div>
        )
    }
}
